import { Link } from '@tanstack/react-router';
import { ChevronsUpDown, LogOut, Settings } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar } from 'src/components/avatars/Avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'src/components/ui/dropdown-menu';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from 'src/components/ui/sidebar';
import { useLogout } from 'src/hooks/useLogout';
import { useUser } from 'src/hooks/useUser';
import { cn } from 'src/lib/utils';
import { PreferencesDefaultRoute } from 'src/routes/preferences';

export function NavUser() {
  const { isMobile, state } = useSidebar();
  const { logout } = useLogout();
  const { t } = useTranslation('navigation');
  const { user } = useUser();

  return (
    <SidebarMenu className='z-[9999]'>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size='lg'
              className='data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground hover:bg-item-hover'
            >
              <Avatar
                className={cn(
                  state === 'expanded' ? 'rounded-full' : 'rounded-md pr-1',
                )}
                firstname={`${user?.firstName}`}
                lastname={`${user?.lastName}`}
              />
              <div className='grid flex-1 text-left text-sm leading-tight'>
                <span className='truncate font-semibold'>{`${user?.firstName} ${user?.lastName}`}</span>
                <span className='truncate text-xs'>{user?.email}</span>
              </div>
              <ChevronsUpDown className='ml-auto size-4' />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className='w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg'
            side={isMobile ? 'bottom' : 'right'}
            align='end'
            sideOffset={4}
          >
            <DropdownMenuLabel className='p-0 font-normal'>
              <div className='flex items-center gap-2 px-1 py-1.5 text-left text-sm'>
                <Avatar
                  firstname={`${user?.firstName}`}
                  lastname={`${user?.lastName}`}
                />
                <div className='grid flex-1 text-left text-sm leading-tight'>
                  <span className='truncate font-semibold'>{`${user?.firstName} ${user?.lastName}`}</span>
                  <span className='truncate text-xs'>{user?.email}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <Link to={PreferencesDefaultRoute.to} className='w-full'>
                <DropdownMenuItem className='cursor-pointer'>
                  <Settings />
                  {t('preferences')}
                </DropdownMenuItem>
              </Link>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => void logout()}>
              <LogOut />
              {t('logout')}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
